import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import cookie from 'react-cookies'
import axios from 'axios';
import { WEB_BASE_URL } from '../../../unified/webbase';
import { useNavigate } from 'react-router-dom';
export default function RequestForWhitelabel() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    appName: '',
    appColor: '#000000',
    privacyUrl: '',
    supportEmail: '',
    supportPhone: '',
    businessName: '',
  });
  const [appLogo, setAppLogo] = useState(null);
  const token = cookie.load("token")
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setAppLogo(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const iid = toast.loading("Please wait...");
    const submitData = new FormData();
    submitData.append('appName', formData.appName);
    submitData.append('businessName', formData.businessName);
    submitData.append('appColour', formData.appColor);
    submitData.append('faqUrl', formData.privacyUrl);
    submitData.append('supportEmail', formData.supportEmail);
    submitData.append('supportPhoneNumber', formData.supportPhone);
    if (appLogo) {
      submitData.append('file', appLogo);
    }

    try { 
      // Replace with your API endpoint
      axios
      .post(WEB_BASE_URL + "/onboarding/submit-kyc", submitData, {
        headers: {
          authorization: token,
        },
      })
      .then((res) => {
       
        console.log(res.data);
        if (res.data.status === "2000") {
          //TODO: navigate to the page after success message
          navigate('/view-white-label-request-info');
          toast.update(iid, {
            render: res.data.message,
            type: "success",
            isLoading: false,
          });
         
        } else {
          toast.update(iid, {
            render: res.data.message,
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        console.log(token);
      });
      
     
    } catch (error) {
      toast.update(iid, {
        render: 'Error submitting request',
        type: "error",
        isLoading: false,
      });
      console.error('Error:', error);
    }
  };

  return (
    <main className="page-content">
        <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Request for White Label</h5>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">App Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="appName"
                                        value={formData.appName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Business Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="businessName"
                                        value={formData.businessName}
                                        onChange={handleInputChange}
                                    />    
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">App Color</label>
                                    <input
                                        type="color"
                                        className="form-control form-control-color"
                                        name="appColor"
                                        value={formData.appColor}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                

                                <div className="mb-3">
                                    <label className="form-label">Privacy Policy URL</label>
                                    <input
                                        type="url"
                                        className="form-control"
                                        name="privacyUrl"
                                        value={formData.privacyUrl}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">App Logo</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Support Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="supportEmail"
                                        value={formData.supportEmail}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Support Phone Number</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name="supportPhone"
                                        value={formData.supportPhone}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary">
                                    Submit Request
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
  )
}
